import { useState } from 'react';
import { Button, Divider, Form, Input, Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import { css } from '@emotion/css';
import DepartmentItemSelect from './DepartmentItemSelect';

export interface JolectAuthFormValues {
  code: string;
  departmentIds: number[];
}

export interface JolectAuthFormProps {
  loading?: boolean;
  onSubmit: (values: JolectAuthFormValues) => Promise<void>;
}

const { useForm } = Form;

const JolectAuthForm = (props: JolectAuthFormProps) => {
  const { loading, onSubmit } = props;
  const { t } = useTranslate();
  const [form] = useForm();
  const [departmentIds, setDepartmentIds] = useState<number[]>([]);

  return (
    <Form
      form={form}
      layout="vertical"
      className={formClassName}
      onFinish={async (values: { code: string }) => {
        await onSubmit({
          code: values.code,
          departmentIds,
        });
      }}
    >
      <Form.Item
        label={
          <div className="flex items-center justify-between w-full">
            <span className="font-bold">{t('domain.jolect.field.storeToken')}</span>
            <div>
              <Button
                className="!px-0"
                type="link"
                href={import.meta.env.VITE_JOLECT_INSTALL_URL}
                target="_blank"
                rel="noreferrer"
              >
                {t('scene.storeAuth.jolectDialog.action.installApp')}
              </Button>
              <Divider type="vertical" className="!mx-2" />
              <Tooltip title={t('scene.storeAuth.jolectDialog.hint.getToken')}>
                <Button className="!px-0" type="link" rel="noreferrer">
                  {t('scene.storeAuth.jolectDialog.action.getToken')}
                </Button>
              </Tooltip>
            </div>
          </div>
        }
        name="code"
        rules={[
          {
            required: true,
            message: t('scene.storeAuth.jolectDialog.validation.storeTokenRequired'),
          },
        ]}
      >
        <Input.TextArea
          maxLength={32}
          showCount
          autoSize={{ minRows: 1, maxRows: 1 }}
          placeholder={t('scene.storeAuth.jolectDialog.placeholder.storeToken')}
          allowClear
        />
      </Form.Item>

      <DepartmentItemSelect
        platform="jolect"
        value={departmentIds}
        showRequiredMark={true}
        onChange={setDepartmentIds}
      />

      <div className="flex justify-center mt-8">
        <Button type="primary" htmlType="submit" loading={loading}>
          {t('scene.storeAuth.jolectDialog.action.confirmAdd')}
        </Button>
      </div>
    </Form>
  );
};

const formClassName = css`
  .ant-form-item-label > label {
    width: 100%;
  }
`;

export default JolectAuthForm;
